import { PDFDownloadLink } from "@react-pdf/renderer";
import ReportPDF from "./RepasseReportPDFRealizado"; // AJUSTE este caminho se necessário
import { getCurrentDateTime } from "../utils/getCurrentDateTime";

const DownloadButton = ({ dataPayments, rawData }) => {
  const currentDateTime = getCurrentDateTime();
  const fileName = `relatorio_empresa_realizante_${currentDateTime}.pdf`;

  return (
    <PDFDownloadLink
      document={<ReportPDF payment={dataPayments} data={rawData || []} />}
      fileName={fileName}>
      {({ loading }) => (loading ? "Gerando PDF..." : "Baixar PDF")}
    </PDFDownloadLink>
  );
};

export default DownloadButton;
